import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,{attrs:{"justify":"center","align":"center"}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12","lg":"6"}},[_c('h1',{staticClass:"caption"},[_vm._v("Error 404")]),_c('h2',[_vm._v("¡Ooops! Algo salió mal")]),_c('h3',[_vm._v("Página no encontrada")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }